import { Component } from '@angular/core';
import { EasterEggService } from 'src/app/services/shared/easter-egg.service';

/**
 * Modal component per l'easter egg del maintainer.
 * Vedi `EasterEggService` per rationale + state machine.
 *
 * Il template si adatta automaticamente allo state del service:
 *   - `armed`  countdown 10s con bomba pulsante
 *   - `boom`   schermo nero fumoso + esplosione
 *   - `joke`   flash verde "SCHERZONE!"
 *   - `secret` GIF + messaggio personale (solo maintainer)
 *   - `idle`   modale hidden (non renderizzato)
 */
@Component({
  selector: 'app-easter-egg-modal',
  templateUrl: './easter-egg-modal.component.html',
  styleUrls: ['./easter-egg-modal.component.scss'],
  standalone: false,
})
export class EasterEggModalComponent {
  constructor(public readonly easter: EasterEggService) {}
}
